function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null);

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M-1236.88,117.61a6.38,6.38,0,0,1-3.33-.94L-1266.13,101l-25.95,15.65a6.39,6.39,0,0,1-7.08-.33,6.38,6.38,0,0,1-2.44-6.63l6.84-29.47-22.9-19.84a6.43,6.43,0,0,1-1.88-6.83,6.41,6.41,0,0,1,5.52-4.39l30.19-2.58,11.8-28.2a6.64,6.64,0,0,1,5.88-4.22h0a6.66,6.66,0,0,1,5.89,4.24l11.79,28,30.19,2.65a6.43,6.43,0,0,1,5.53,4.49,6.41,6.41,0,0,1-1.94,6.82l-22.85,19.82,6.85,29.5a6.37,6.37,0,0,1-2.46,6.63A6.39,6.39,0,0,1-1236.88,117.61Zm2.67-6.11h0Zm-58.72,0h0Zm56.7-1.38h0Zm-29.9-18,27.3,16.47-7.21-31,24.1-20.9-31.77-2.72-12.43-29.35-12.42,29.35-31.78,2.72,24.11,20.9-7.21,31Zm46.45-37.45h0ZM-1269,21.71h0Zm6.52,0h0Z",
  transform: "translate(1319.84 -14.19)"
});

var SvgOpportunitiesIcon = function SvgOpportunitiesIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 107.42 103.42",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOpportunitiesIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Opportunities_icon.3055ed28.svg";
export { ForwardRef as ReactComponent };